import { ConsumableLifetimeCycleThemeModeConfig } from './types';

const dark: ConsumableLifetimeCycleThemeModeConfig = {
  consumableLifetimeCycle: {
    normalButtonBGColor: '#505251',
    normalButtonBorderColor: '2px solid #267DAC',
  },
};

export default dark;
